import React, { useState } from 'react';
import '../styles/Navbar.css';
import { FaShoppingCart, FaUserPlus, FaSignInAlt, FaBars, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavigate = () => {
    navigate("/");
  }

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={handleNavigate}>
        {/* image logo */}
        <img src="/assets/logo.png" alt="Logo" className="logo-image" />
        {/* text logo */}
        <span className="logo-text"></span>
      </div>

      {/* Desktop Menu */}
      <ul className="navbar-links">
        <NavItem icon={<FaShoppingCart />} label="Cart" />
        <NavItem icon={<FaUserPlus />} label="Become Seller" />
        <NavItem icon={<FaSignInAlt />} label="Login" />
      </ul>

      {/* Hamburger Icon */}
      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Mobile Menu */}
      <ul className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <NavItem icon={<FaShoppingCart />} label="Cart" />
        <NavItem icon={<FaUserPlus />} label="Become Seller" />
        <NavItem icon={<FaSignInAlt />} label="Login" />
      </ul>
    </nav>
  );
}

function NavItem({ icon, label }) {
  return (
    <li className="nav-item">
      {icon}
      <span>{label}</span>
    </li>
  );
}

export default Navbar;
